module.exports = __webpack_public_path__ + "img/logo-taipei-city.32834a99.svg";